const initHeaderSearch = () => {
  const searchShow = document.querySelector('.search-show');
  
  if (searchShow) {
    const searchForm = document.querySelector('.searchform');
    const searchFormMobile = document.querySelector('.searchform-mobile');
    const panel = document.getElementById(searchShow.getAttribute('aria-controls'));

    searchShow.addEventListener('click', (e) => {
      e.preventDefault();
      searchForm.classList.toggle('uk-hidden');
      searchShow.classList.toggle('uk-hidden');

      const expanded = searchShow.getAttribute('aria-expanded') === 'true';
      searchShow.setAttribute('aria-expanded', String(!expanded));
      panel.hidden = expanded;

      if (!expanded) {
        const field = panel.querySelector('input, textarea, select, [tabindex]:not([tabindex="-1"])');
        if (field) field.focus();
      } else {
        searchShow.focus();
      }
    });
  }
};

export default initHeaderSearch;
